<template>
  <DxPopup @hidden="onHidden" :visible="showXlsImport" :show-close-button="true" :show-title="true" :title="title" height="auto" width="500" :container="container">
    <v-row no-gutters class="pb-4">
      <v-col>
        <v-file-input class="pa-0" placeholder="File input" v-model="selectedFile" />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="d-flex justify-end">
        <v-btn class="pa-2" style="text-transform: none; font-family: Roboto, sans-serif;" @click.stop="save">
          Save As Excel
        </v-btn>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup'
import { saveAsExcel } from '@/api/view/hip/common/commonXls'
import baseview from '@/components/base/baseview.vue'
import notify from 'devextreme/ui/notify'

export default {
  name: 'saveAsExcelPop',
   mixins: [baseview],
  components: {
    DxPopup
  },
  props: {
    container: {
      type: String,
      default() {
        return '.v-application'
      }
    },
    title: {
      type: String,
      default() {
        return 'Save As Excel'
      }
    },
    showXlsImport: {
      type: Boolean,
      default() {
        return false
      }
    },
    url: {
      type: String,
      default() {
        return ''
      }
    },
    param: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      selectedFile: null
    }
  },
  watch: {
    'showXlsImport': {
      handler(value, oldValue) {
        this.selectedFile = null
      },
      immediate: true
    }
  },
  methods: {
    save() {
      if(!this.selectedFile) {
        this.vToastify(this.$t('Excel File is not Selected.'), 'warn')
        return
      }

      // console.log('this.selectedFile', this.selectedFile)

      const arr = this.selectedFile.name.split('.xls')
      if(arr.length < 2) {
        this.vToastify(this.$t('Selected File is not Excel File'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          const formData = new FormData()

          formData.append('file', this.selectedFile)
          Object.keys(this.param).forEach(key => {
            formData.append(key, this.param[key])
          })

          // console.log('this.selectedFile', this.selectedFile)
          // console.log('param', formData.get('file'))
          
          saveAsExcel(this.url, formData).then(res => {
            // console.log('saveAsExcelRes', res)
            notify(this.$t('Save As Excel is completed.'), 'success', 3000)
            this.$emit('saved')
            this.$emit('update:showXlsImport', false)
          }).catch(error => {
            this.vToastify(error, 'warn')
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        true
      )
    },
    onHidden(e) {
      this.$emit('update:showXlsImport', false)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>